import { Icon } from '@iconify/react';
import { Button, Tab, Tabs } from '@nextui-org/react';
import { useState } from 'react';
import DataSetsTab from './tabs/data-sets-tab';
import MetricsTab from './tabs/metrics-tab';
import PlaygroundTab from './tabs/playground-tab';

export default function EvaluationsPage() {
  const [activeTab, setActiveTab] = useState('datasets');
  const [showAddDatasetButton, setShowAddDatasetButton] = useState(true);

  const renderAddDatasetButton = (className?: string) => (
    <Button
      startContent={<Icon icon="mdi:plus" />}
      color="primary"
      size="sm"
      className={className}
    >
      Add Dataset
    </Button>
  );

  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">
      <div className="min-h-0 flex-1 overflow-y-auto p-2 sm:p-8">
        <div className="flex items-center justify-between gap-2 mb-4 sm:mb-6">
          <h1 className="text-2xl font-semibold">Evaluations</h1>
          {activeTab === 'datasets' &&
            showAddDatasetButton &&
            renderAddDatasetButton('flex-shrink-0 sm:hidden')}
        </div>
        <Tabs
          aria-label="Evaluation options"
          selectedKey={activeTab}
          onSelectionChange={(key) => setActiveTab(String(key))}
        >
          <Tab key="datasets" title="Data Sets">
            <DataSetsTab onShowAddButtonChange={setShowAddDatasetButton} />
          </Tab>
          <Tab key="metrics" title="Scorers">
            <MetricsTab />
          </Tab>
          <Tab key="playground" title="Experiments">
            <PlaygroundTab />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
